import React from 'react';
import { Button, Gutter, PillsItem, Pills } from '@axiom/ui';
import type { CandidateAlertWorkFeed } from '@axiom/validation';

import type { FilterPill } from '../../types/work-feed.types';

import { useWorkFeedAlertsPills } from './useWorkFeedAlertsPills';

export type WorkFeedAlertsPillsProps = {
  workFeedAlert: CandidateAlertWorkFeed;
  onClear?: (pill: FilterPill) => Promise<void>;
  onClearAll?: () => Promise<void>;
  name?: string;
};
export const WorkFeedAlertsPills = ({
  workFeedAlert,
  onClear,
  onClearAll,
  name = 'WORK_FEED_ALERTS_PILLS_WRAPPER',
}: WorkFeedAlertsPillsProps) => {
  const pills = useWorkFeedAlertsPills(workFeedAlert);

  return (
    <div data-test={name}>
      {pills.length > 0 && (
        <>
          <Pills name="WORK_FEED_ALERTS_PILLS">
            {pills.map(pill => (
              <PillsItem
                name={pill.value}
                data-value={pill.value}
                key={pill.value}
                pattern="secondary"
                onDismiss={onClear ? async () => onClear(pill) : undefined}
              >
                {pill.label}
              </PillsItem>
            ))}
          </Pills>
          {!!onClearAll && (
            <Button
              name="CLEAR_ALL"
              onClick={() => {
                void onClearAll();
              }}
              variation="minimal"
              pattern="secondary"
            >
              Clear All
            </Button>
          )}
          <Gutter name="GUTTER" bottom="8px" />
        </>
      )}
    </div>
  );
};
